import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ReservationLedgerService } from '../reservation-ledger.service';
import { ReservationLedger } from '../reservation-ledger';
import { first } from 'rxjs/operators';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import {SharedService} from "@app/_components/_shared/shared.service";

@Component({
    selector: 'app-reservation-ledger',
    templateUrl: './reservation-ledger.component.html',
    styleUrls: ['./reservation-ledger.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ReservationLedgerComponent implements OnInit {
    orderProducts: any;
	orderDetails: any;
	chartAccounts: any;
	users: string[];
    payToDetails: any;

	showReservationSearch = false;
	reservation: any;
	loading: boolean;
	reservationId: any;
	title = "Reservation";

	constructor(
		private userService: UserService,
		private primengConfig: PrimeNGConfig,
		private reservationService: ReservationService,
		private reservationLedgerService: ReservationLedgerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,

		private sharedService: SharedService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.reservationLedger = data.reservationLedger,
			this.reservationId = data.reservationLedger?.reservationId,
			this.reservation = undefined;
			this.statuses = reservationLedgerService.statuses;
			this.payToDetails = reservationLedgerService.payToDetails
			this.ledgerItemTypes = reservationLedgerService.ledgerItemTypes;
	}

	@Input() reservationLedger: ReservationLedger;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	reservationLedgerId: number;
	isUpdate: boolean = false;

  isAllowedToUpdateOpsNotes: boolean = false;
	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	isReservationId: boolean = false;

	statuses: any;

	ledgerItemTypes: any;

	disableTitle: boolean= false;

  opsNotes: any = ''

	validationMessages =
		{
			reservationLedgerId: [],
			status: [],
			ledgerItemType: [],
			payFrom: [],
			payTo: [],
			title: [],
			quantity: [],
			listPrice: [],
			listPriceAdjustmentPercent: [],
			listPriceAdjustmentAmount: [],
			propertyCode:[],
			guestLastName:[],
			checkInDate:[],
			checkOutDate:[],
			opsNotes: [],
			ownerNotes: [],

			// reservationLedgerer
			payFromOrderDetailId: [],
			payFromOrderProductId: [],
			orderProductId: [], // done by Dipesh
			chartAccountId: [], // please add as dropdown, see orderProductId and use same exact process
			reservationId: [], // please add as search, see review.component

		};

	ngOnInit() {
		this.fetchReservations();
		this.findAllOrderProducts();
		this.findAllOrderDetails()
		//this.findAllChartAccounts();
		//this.fetchUsers();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole reservationLedger object
		if (this.reservationLedger) {
			this.reservationLedgerId = this.reservationLedger.reservationLedgerId;
			this.isUpdate = this.reservationLedger?.reservationLedgerId > 0;
			if(!this.isUpdate){
				this.reservationLedger.ledgerItemType = 1;
			}
			this.disableTitle = this.isUpdate && this.reservationLedger.ledgerItemType === 2;
			this.reservationLedger.checkInDate = moment(this.reservationLedger?.checkInDate).toDate();
			this.reservationLedger.checkOutDate = moment(this.reservationLedger?.checkOutDate).toDate();
			this.fixDates();
			this.form1.patchValue(this.reservationLedger);
      this.isAllowedToUpdateOpsNotes = this.getAllowedToUpdateOpsNotes();
      this.opsNotes = this.reservationLedger?.opsNotes;
		}
	}

  getAllowedToUpdateOpsNotes(){

    if (this.isUpdate &&  this.reservationLedger.ledgerItemType !== 2){
      return true;
    }

    if (this.isUpdate && this.reservationLedger.ledgerItemType === 2){
      if (this.reservationLedger?.listPrice <=0){
        return true;
      }
    }
    return false;

  }


	// onFindReservationClick() {
	// 	this.showReservationSearch = !this.showReservationSearch;
	// }


	fetchReservations() {
		if(!this.isUpdate){
			try {
				let filters = {
				}
				if (this.reservationId) {
					// show only activities that are assigned to this activityProviderId
					let reservationIdFilter = { 'reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
					Object.assign(filters, reservationIdFilter);
				}
				let multiSortMeta = [];
				multiSortMeta.push({ field: 'createDate', order: -1 });
				this.reservationService.findByAgentListFilter(
					0, 1,
					'createDate',
					'desc',
					multiSortMeta,
					undefined,
					filters).pipe(first()).subscribe(

					res => {
						// console.log('reservations are: ' + JSON.stringify(apiResponse));
						 if(res.data?.reservations?.length > 0){
							 this.reservation = res.data?.reservations[0];
							 this.reservationLedger.checkInDate = this.reservation.checkInDate;
							 this.reservationLedger.checkOutDate = this.reservation.checkOutDate;
							 this.reservationLedger.propertyCode = this.reservation.propertyCode;
							 this.reservationLedger.guestLastName = this.reservation.guestLastName;
							 this.reservationLedger.checkInDate = moment(this.reservationLedger?.checkInDate).toDate();
							 this.reservationLedger.checkOutDate = moment(this.reservationLedger?.checkOutDate).toDate();
							 this.form1.patchValue(this.reservationLedger);
							 return this.reservation;
						 }
					},
					error => {
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
						this.loading = false;
					},
					() => { this.loading = false; }
				);

			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	}

	reservationInfoItem(event : any){
		console.log("reservation reservation : "+ JSON.stringify(event));
		this.isReservationId = false;
		this.reservationId = event.reservationId;
		this.form1.patchValue({
			shortTermRentalId: event.shortTermRentalId,
			propertyCode: event.propertyCode,
			guestLastName: event.lastName,
			checkInDate: moment(event.checkInDateTime).toDate(),
			checkOutDate: moment(event.checkOutDateTime).toDate(),
		});
	}



	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.reservationLedgerId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.reservationLedgerService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservationLedger = res.data.reservationLedger;
						this.doAdd.emit(this.reservationLedger);
					},
					(err: any) => {
						console.log('reservationLedger-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('reservationLedger: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.reservationLedgerService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservationLedger = res.data.reservationLedger;
            if (this.isAllowedToUpdateOpsNotes){
              this.updateTaxes();
            }else{
              this.doUpdate.emit(this.reservationLedger);
            }
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
  updateTaxes(){
    if(this.opsNotes !== this.form1.value['opsNotes']){
      this.reservationLedgerService.updateLedgerTax(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.reservationLedger = res.data.reservationLedger;
            this.doUpdate.emit(this.reservationLedger);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.doUpdate.emit(this.reservationLedger);
          },
          () => { this.formLoading = false; });
    }else{
      this.doUpdate.emit(this.reservationLedger);
    }

  }

	formDelete() {
		try {
			this.reservationLedgerService.delete(this.reservationLedger.reservationLedgerId)
				.subscribe(
					(res: any) => {
						console.log('reservationLedger-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.reservationLedger);
					},
					(err: any) => {
						console.log('reservationLedger-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			reservationLedgerId: [this.reservationLedgerId],
			status: [],
			ledgerItemType: [],
			payFrom : [this.reservationLedgerService.payToDetails[1].value],
			payTo: [this.reservationLedgerService.payToDetails[2].value],
			title: [],
			quantity: [],
			listPrice: [],
			listPriceAdjustmentPercent: [],
			listPriceAdjustmentAmount: [],
			propertyCode:[],
			guestLastName:[],
			// checkInDateTime:[],
			// checkOutDateTime:[],
			checkInDate:[],
			checkOutDate:[],
			opsNotes: [],
			ownerNotes: [],
			payFromOrderDetailId: [],
			payFromOrderProductId: [],

			// reservationLedgerer
			orderProductId: [],
			chartAccountId: [],
			reservationId: [this.reservationId],
			enteredByUserId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.reservationLedger.reservationLedgerDate = moment(this.reservationLedger.reservationLedgerDate).toDate();
	}

	findAllOrderProducts() {
		this.reservationLedgerService.findLedgerOrderProduct().pipe(first()).subscribe(
			res => {
				this.orderProducts = res.data.orderProducts;
			},
			err => {
				console.log('error In findReservationLedgerById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve the order products.' + err.message, sticky: false });
			},
			() => { this.formLoading = false; });
	}

	// To get list of reservation order details
	findAllOrderDetails() {
			try {
				let filters = {
				}
				if (this.reservationId) {
					let reservationIdFilter = {
						'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' }
					};
					Object.assign(filters, reservationIdFilter);
				}else{
					this.orderDetails = [];
					return;
				}
				let multiSortMeta = [];
				multiSortMeta.push({ field: 'createDate', order: -1 });
				this.sharedService.findByAgentListFilter(
					'order-details',
					0, 100,
					'createDate',
					'desc',
					multiSortMeta,
					undefined,
					filters).pipe(first()).subscribe(

					res => {
						// console.log('reservations are: ' + JSON.stringify(apiResponse));
						if(res.data?.orderDetails?.length > 0){
							this.orderDetails = res.data.orderDetails;


							let filteredOrderProduct = this.orderDetails.filter(orderDetail =>
							{
								return orderDetail.orderProductId === 1;
							});
							if(filteredOrderProduct.length > 0 && !this.isUpdate){
								let selectedOrderProduct = filteredOrderProduct[0];
								this.reservationLedger.payFromOrderDetailId = selectedOrderProduct.orderDetailId
								this.reservationLedger.payFromOrderProductId = selectedOrderProduct.orderProductId
								this.reservationLedger.quantity = selectedOrderProduct.quantity
								this.reservationLedger.listPrice = -0;
								this.form1.patchValue(this.reservationLedger);
							}
							return this.orderDetails;
						}
					},
					error => {
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
						this.loading = false;
					},
					() => { this.loading = false; }
				);

			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	onProductSelect($event: any) {
		if(this.orderProducts){
			let filteredOrderProduct = this.orderProducts.filter(orderProduct =>
			{
				return orderProduct.orderProductId === this.form1.value?.orderProductId;
			});
			if(filteredOrderProduct.length > 0){
				let selectedOrderProduct = filteredOrderProduct[0];
				this.reservationLedger.listPrice =  selectedOrderProduct.listPrice;
				this.reservationLedger.title = selectedOrderProduct.description;
				this.reservationLedger.orderProductId = selectedOrderProduct.orderProductId
				this.form1.patchValue(this.reservationLedger);
			}
		}
	}
	onOrderDetailSelect($event: any) {
		if(this.orderDetails){
			let filteredOrderProduct = this.orderDetails.filter(orderDetail =>
			{
				return orderDetail.orderDetailId === this.form1.value?.payFromOrderDetailId;
			});
			if(filteredOrderProduct.length > 0){
				let selectedOrderProduct = filteredOrderProduct[0];
				this.reservationLedger.payFromOrderProductId = selectedOrderProduct.orderProductId
				this.form1.patchValue(this.reservationLedger);
			}
		}
	}


}
